module.exports = __webpack_public_path__ + "static/media/spider-black-widow.452bcb2c.svg";